export const SITE_TYPE = {
    IRM_CUPIS: 2
}


// WEBPACK FOOTER //
// ./src/config/index.js